import apiCall, { apiRequest } from '../../apiCall'

export const getTransaction = (params, userId) => apiRequest('Transaction.Transaction', { ...params }, userId ? `/${userId}` : '')
export const getTransactionPDF = (params) => apiRequest('Transaction.TransactionPDF', {}, params ? `/${params}` : '')
export const getListTransactionAdmin=(params)=>apiRequest('Transaction.TransactionAdmin', { ...params })
